import type { HTMLAttributes, ReactNode, ForwardedRef } from 'react';

import { forwardRef, memo } from 'react';

import useClassy from '@core/hooks/useClassy';

import './style.scss';

type Props = HTMLAttributes<HTMLSpanElement> & {
  allCaps?: boolean;
  children?: ReactNode;
  circular?: boolean;
  className?: string;
  ghost?: boolean;
  kind?: 'callout' | 'danger' | 'info' | 'inverted' | 'neutral' | 'success' | 'warning';
  size?: 'xs' | 'sm';
  muted?: boolean;
};

const Badge = memo(
  forwardRef(
    (
      {
        allCaps = false,
        children,
        circular = true,
        className,
        ghost = false,
        kind = 'neutral',
        muted = false,
        size = 'xs',
        ...attrs
      }: Props,
      ref?: ForwardedRef<HTMLElement>,
    ) => {
      const bem = useClassy(undefined, 'Badge');

      return (
        <span
          ref={ref}
          className={bem(
            className,
            '&',
            `_${kind}`,
            `_${size}`,
            allCaps && '_allCaps',
            circular && '_circular',
            ghost && '_ghost',
            muted && '_muted',
          )}
          {...attrs}
        >
          <span className={bem('-contentContainer')}>{children}</span>
        </span>
      );
    },
  ),
);

Badge.displayName = 'Badge';

export default Badge;
